import React from 'react'
import Menu from '../../../../components/Menu'
import MenuItem from '../../../../components/MenuItem'







export const OrgTeamMembersMenu = (props) => {
  const {menuProps, openDeleteTeamModal} = props
  const {closePortal} = menuProps

  return (
    React.createElement(Menu, { ariaLabel: 'Select your action', ...menuProps,}
      , React.createElement(MenuItem, {
        label: "Delete team" ,
        onClick: () => {
          closePortal()
          openDeleteTeamModal()
        },}
      )
    )
  )
}
